module.exports = "<bs-navbar></bs-navbar>\n\n<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main